<div class="content-wrapper">
  <main>
    <alert></alert>
    <router-outlet></router-outlet>
  </main>
</div>
